import { CartItemEntitiesEndpoint as CartItemEntitiesEndpointInterface } from '@apiClient/interfaces/endpoints/CartItemEntities.endpoint';
import ApiResponseDto from '@apiClient/interfaces/response/ApiResponse.dto';
import { KyInstance } from "ky/distribution/types/ky";
import { KyResponse } from 'ky';
import CartStateDto from '@/projectRoot/api-client/interfaces/models/webshop/cart/CartState.dto';
import CartDto from '@/projectRoot/api-client/interfaces/models/webshop/cart/Cart.dto';
import BonRequestDto from '@/projectRoot/api-client/interfaces/request/cart/BonRequest.dto';
import BonDto from '@/projectRoot/api-client/interfaces/models/marketing/Bon.dto';
import { buildSearchParams } from '@/projectRoot/src/utils/handlers/urlHandler';

export class CartItemEntitiesEndpoint implements CartItemEntitiesEndpointInterface {

    private _httpClient: KyInstance;
    private cache: RequestCache;

    public constructor(client: KyInstance, cache: RequestCache = "force-cache") {
        this._httpClient = client;
        this.cache = cache;
    }

    get httpClient(): KyInstance {
        if (!this._httpClient) {
            throw new Error('Ky http client is not initialized');
        }
        return this._httpClient;
    }

    set httpClient(kyInstance: KyInstance) {
        this._httpClient = kyInstance;
    }

    /**
    * /api/marketing/bon/by-code
    */
    async bonByCode(params: BonRequestDto): Promise<ApiResponseDto<BonDto, undefined>> {
        return this._httpClient
            .get(`marketing/bon/by-code`, { searchParams: params ? buildSearchParams(params) : {}, cache: this.cache })
            .then(async (kyResponse: KyResponse) => {
                if (kyResponse.status < 200 || kyResponse.status > 299) {
                    throw new Error(kyResponse.statusText)
                }
                const response: ApiResponseDto<BonDto, undefined> = await kyResponse.json();
                return response;
            });
    }
}

export default CartItemEntitiesEndpoint;